import actions from './actions';
import { initialMethodologyClusterState, MethodologyClusterState } from './models';

export const reducer = (state = initialMethodologyClusterState, action: any): MethodologyClusterState => {
  switch (action.type) {
    case actions.SET_METHODOLOGY_CLUSTERS:
      return {
        ...state,
        component_clusters: action.payload
      };

    case actions.ADD_METHODOLOGY_CLUSTER:
      return {
        ...state,
        component_clusters: [...state.component_clusters, action.payload]
      };

    case actions.ADD_CLONED_CLUSTERS:
      return {
        ...state,
        component_clusters: [...state.component_clusters, ...action.payload]
      };

    case actions.UPDATE_METHODOLOGY_CLUSTER:
      return {
        ...state,
        component_clusters: state.component_clusters.map(cluster => (cluster.id === action.payload.id ? action.payload : cluster))
      };

    case actions.REMOVE_METHODOLOGY_CLUSTER:
      return {
        ...state,
        component_clusters: state.component_clusters.filter(cluster => cluster.id !== action.payload)
      };

    case actions.REMOVE_COMPONENT_FROM_CLUSTER:
      return {
        ...state,
        component_clusters: state.component_clusters
          .map(cluster => ({
            ...cluster,
            components_ids: cluster.components_ids.filter(componentId => componentId !== action?.payload)
          }))
          .filter(cluster => cluster.components_ids.length > 0)
      };

    case actions.REMOVE_CLUSTERS_BY_PHENOMENON_ID:
      return {
        ...state,
        component_clusters: state.component_clusters.filter(cluster => cluster.phenomenon_id !== action.payload)
      };

    default:
      return state;
  }
};

export default reducer;
